export default __webpack_public_path__ + "static/media/quick-beta-card-img.36abc5d3.svg";